import { PanelDefinition, UnknownSpec } from '../../../core';

/**
 * The middleware applied to the DashboardStore (can be used as generic argument in StateCreator).
 */
export type Middleware = [['zustand/immer', never], ['zustand/devtools', never]];

declare global {
  var dashboardStoreId: number;
}

/**
 * Helper function to generate unique IDs for things in the dashboard store that don't have a "natural" ID.
 */
export function generateId() {
  if (globalThis.dashboardStoreId === undefined) {
    globalThis.dashboardStoreId = 0;
  }
  return globalThis.dashboardStoreId++;
}

/**
 * Helper function to create initial PanelDefinitions. Important to keep in sync with usePanelEditor
 * when adding new options to avoid discard changes dialog showing unnecessarily.
 */
export function createPanelDefinition(defaultPanelKind?: string, defaultPanelSpec?: UnknownSpec): PanelDefinition {
  return {
    kind: 'Panel',
    spec: {
      display: {
        name: '',
        description: '',
      },
      plugin: {
        kind: defaultPanelKind ?? '',
        spec: defaultPanelSpec ?? {},
      },
      queries: [],
      query_options: undefined,
      links: [],
      formulas: [],
    },
  };
}
